import React from 'react'

const SvgCheckCircleFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10c0 5.522-4.477 10-10 10S2 17.522 2 12zm13.294-3.707l-5.293 5.293-2.294-2.294a1 1 0 10-1.414 1.414l3.001 3.001a1 1 0 001.414 0l6-6a1 1 0 10-1.414-1.414z' />
  </svg>
)

export default SvgCheckCircleFilled
